.loading {
  opacity: 0.3;
  transition: opacity 0.3s ease;
}

/* 4-column grid with 20px gutters between the bordered cards. */
.nsProductGrid {
  display: grid;
  grid-template-columns: repeat(4, 1fr);
  gap: 20px;
  margin: 0;
  padding: 0;
  list-style: none;
  font-family: Oxygen, sans-serif;
}

/* 2 columns on mobile. */
@media (max-width: 768px) {
  .nsProductGrid {
    grid-template-columns: repeat(2, 1fr);
  }
}
